<template>
  <component
    :is="tag"
    :class="['heading-base', { 'no-top-margin': noTopMargin }]"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    tag: { type: String, default: "h1" },
    noTopMargin: { type: Boolean, default: false }
  }
};
</script>

<style scoped lang="scss">
.heading-base {
  margin: 1em 0 0.5em;
  font-family: var(--header-font-family);
  font-weight: bold;
}
.no-top-margin {
  margin-top: 0;
}
h1 {
  font-size: 1.5em;
}
h2 {
  font-size: 1.4em;
}
h3 {
  font-size: 1.3em;
}
h4 {
  font-size: 1.2em;
}
h5 {
  font-size: 1.1em;
}
h6 {
  font-size: 1em;
}
</style>
